import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import { useModal } from "../contexts/ModalContext";
import Content from "../Modulos/Checklist/Body/Content";

const CheckListHome = () => {

    const { openModal } = useModal();

    const abrirMenuLateral = () => {

        openModal("sidebarChecklist")

    }

    return(
        <>
            <NavBar title="CHECKLIST" setSideBar={ abrirMenuLateral } goBackOnePage />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    )

}

export default CheckListHome;